<template>
    <b-col class="data-entry mb-3"
           cols="12"
           sm="12"
           :md="fullWidth ? '12' : '6'"
           :lg="fullWidth ? '12' : '3'"
           :xl="fullWidth ? '12' : '3'"
    >
        <div
            v-if="!isLoading"
            :class="{ 'abbreviated-text': abbreviated }">
            <div class="headline">
                <span class="title pb-2">
                    <b>
                        <font-awesome-icon :icon="[iconVariant, icon]" v-if="icon" class="pr-2"/><span v-html="title"></span>
                    </b>
                </span>
                <div class="action pl-3"><slot name="action"></slot></div>
            </div>
            <slot name="value"></slot>
            <span
                :class="{ 'abbreviated-text': abbreviated }"
                class="value"
                v-html="value"
                :title="value"
                :itemprop="itemprop"></span>
        </div>
        <div v-else>
            <data-entry-column-skeleton></data-entry-column-skeleton>
        </div>
    </b-col>
</template>

<script>
import { BCol } from "bootstrap-vue";
import DataEntryColumnSkeleton from "./DataEntryColumnSkeleton.vue";

export default {
    name: 'DataEntryColumn',
    components: {
        DataEntryColumnSkeleton,
        BCol
    },
    props: {
        title: {
            require: true
        },
        value: {
            require: false
        },
        itemprop: {
            require: false
        },
        icon: {
            type: String,
            require: false
        },
        iconVariant: {
            type: String,
            default: 'fas'
        },
        isLoading: true,
        fullWidth: false,
        abbreviated: {
            default: true
        }
    }
}
</script>
